// extracted by mini-css-extract-plugin
export default {"loginWrapper":"adminlogin_loginWrapper__4Co8f","special":"adminlogin_special__0gedr"};